import React from "react"
import { graphql, Link } from "gatsby"
import { ListingLayoutPrintVersion } from "@organic-return/foundation-react/src/components/Listing"
import { useSiteContext } from "../components/common/SiteContext"
import SEO from "../components/common/SEO"

export const query = graphql`
  query($nodeID: String!) {
    listing(id: { eq: $nodeID }) {
      id
      baths
      address {
        city
        county
        postal
        text
        street1
        street2
      }
      beds
      details {
        name
        details {
          label
          value
        }
      }
      lotacres
      majorArea
      minorArea
      mlsID
      mlsSourceName
      mlsSourceLogoUrl
      price
      sqft
      status
      statusTS
      subType
      subdivision
      type
      exclusive
      flags
      features
      defaultImage {
        dimensions
        url
      }
      path
      description
      descriptionHTML
      images {
        url
        dimensions
        caption
      }      
      office{
        mlsID
        fullName
        photos{
          url
        }
        address {
          city
          county
          postal
          text
          street1
          street2
          state
        }
        phone
        email
      }
      officeName
      agent {
        mlsID
        first
        last
        fullName
        email
        company
        category
        officeName
        phoneOffice
        photos {
          url
        }
        social {
          channel
          url
        }
        path
        phone
        phoneMobile
        license
        workTitle
        designations
      }      
      propertyDocuments {
        title
        file {
          url
        }
      }
      openHouse {
        startDate
        endDate
        headLine
      }
      tagline
      sEOTitle
      sEODescription
    }
    config: drupalSiteConfiguration {
      logo {
        url
      }
    }    
  }
`

const ListingPrintPage = ({ pageContext, data, location }: any) => {
  const siteContext = useSiteContext();

  const Layout = ListingLayoutPrintVersion

  let layoutProps = data.listing.exclusive
    ? siteContext.exclusiveListingPrintLayoutProps
    : siteContext.listingPrintLayoutProps


  data.listing.office = data.listing.office ?? [];
  data.listing.agent = data.listing.agent ?? [];

  var pageTitle = data.listing.sEOTitle;
  var pageDescription = data.listing.sEODescription ?? "";
  return (
    <>
      <SEO
        title={pageTitle}
        keywords={""}
        description={pageDescription}
        ogImage={data.listing.defaultImage?.url}
        ogType="place"
        location={location}
      />
      <Layout
        className={`mx-auto`}
        listing={data.listing}
        agents={data.listing.agent}
        similar={data.listing.similar}
        title={data.listing.address.text}
        subtitle={data.listing.tagline}
        linkFunc={props => {
          return (
            <Link
              to={props.href ?? ""}
              className={`hide-disabled text-inherit ${props.className}`}
              key={props.key}
              title={props.title}
            >
              {props.children}
            </Link>
          )
        }}
        officeLogo={data.config?.logo}
        {...layoutProps}
      />
    </>
  )
}

export default ListingPrintPage
